module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "withinOrdersPage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "searchView"
  }, [_c('div', {
    staticClass: "cellLs"
  }, [_c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.searchParam.dateType),
      callback: function($$v) {
        _vm.$set(_vm.searchParam, "dateType", $$v)
      },
      expression: "searchParam.dateType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("金额范围：")]), _vm._v(" "), _c('div', {
    staticClass: "rangeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.appointPriceBegin),
      expression: "searchParam.appointPriceBegin"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchParam.appointPriceBegin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "appointPriceBegin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.appointPriceEnd),
      expression: "searchParam.appointPriceEnd"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchParam.appointPriceEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "appointPriceEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popover"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.clearPrice()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.numberType),
      expression: "searchParam.numberType"
    }],
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchParam, "numberType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("老师编号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("订单编号")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.numberStr),
      expression: "searchParam.numberStr"
    }],
    staticClass: "input right",
    attrs: {
      "type": "text",
      "placeholder": _vm.searchParam.numberType === '4' ? '输入老师编号' : '输入订单编号'
    },
    domProps: {
      "value": (_vm.searchParam.numberStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "numberStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("客服id：")]), _vm._v(" "), _c('w-select', {
    attrs: {
      "placeholder": "输入客服id",
      "options": _vm.waiterOptions
    },
    model: {
      value: (_vm.searchParam.waiterId),
      callback: function($$v) {
        _vm.$set(_vm.searchParam, "waiterId", $$v)
      },
      expression: "searchParam.waiterId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "searchHandle"
  }, [_c('button', {
    staticClass: "search",
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "resat",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "searchFilter"
  }, [_c('ul', _vm._l((_vm.options.customerOrderType), function(item, idx) {
    return _c('li', {
      key: idx,
      class: {
        on: item.id == _vm.searchParam.customerOrderType
      },
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tableTools"
  }, [_c('div', [_c('button', {
    staticClass: "create",
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("新建订单")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.batchPay
    }
  }, [_vm._v("批量支付")])]), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "disabled": _vm.page.pageNo <= 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.page.pageNo >= _vm.page.totalPage
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("下一页")])])]), _vm._v(" "), (_vm.fillData.datas && _vm.fillData.datas.length) ? _c('div', {
    staticClass: "mainTable"
  }, [_c('table', [_c('thead', [_c('tr', [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, "1") > -1 : (_vm.allSelected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("稿件名称")]), _vm._v(" "), _c('td', {
    staticClass: "dubber"
  }, [_vm._v("选定老师")]), _vm._v(" "), _c('td', {
    staticClass: "priced"
  }, [_vm._v("定价")]), _vm._v(" "), _c('td', {
    staticClass: "realPay"
  }, [_vm._v("实际付款")]), _vm._v(" "), _c('td', {
    staticClass: "status"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('td', {
    staticClass: "waiter"
  }, [_vm._v("客服")]), _vm._v(" "), _c('td', {
    staticClass: "duration"
  }, [_vm._v("时长")]), _vm._v(" "), _c('td', {
    staticClass: "handle"
  }, [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fillData.datas || []), function(item) {
    return [_c('tr', {
      key: 'interval_' + item.id,
      staticClass: "interval"
    }), _vm._v(" "), _c('tr', {
      key: item.id,
      staticClass: "orderTd"
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allSelected),
        expression: "allSelected"
      }],
      attrs: {
        "type": "checkbox",
        "value": "1"
      },
      domProps: {
        "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, "1") > -1 : (_vm.allSelected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.allSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.allSelected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('span', {
      class: item.contributionId ? 'down-load' : '',
      on: {
        "click": function($event) {
          return _vm.downContribution(item)
        }
      }
    }, [_vm._v(_vm._s(item.contributionName) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "dubber"
    }, [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('td', {
      staticClass: "priced"
    }, [_vm._v(_vm._s(item.appointPrice))]), _vm._v(" "), _c('td', {
      staticClass: "realPay"
    }, [_vm._v(_vm._s(item.realityPrice))]), _vm._v(" "), _c('td', {
      staticClass: "status"
    }, [_c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已需求'),
        expression: "'已需求'"
      }],
      staticClass: "demand on"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
        expression: "item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'"
      }],
      staticClass: "demo",
      class: {
        on: item.auditionIds
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.payId ? '已经支付订单费用' : '订单尚未支付'),
        expression: "item.payId ? '已经支付订单费用' : '订单尚未支付'"
      }],
      staticClass: "pay",
      class: {
        on: item.payId
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'),
        expression: "item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'"
      }],
      staticClass: "finished",
      class: {
        on: item.productId || item.voiceLength
      }
    }), _vm._v(" "), (item.orderStatus == 10) ? _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已取消'),
        expression: "'已取消'"
      }],
      staticClass: "canceled"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "waiter"
    }, [_vm._v(_vm._s(item.waiterName))]), _vm._v(" "), _c('td', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(item.voiceLength))]), _vm._v(" "), _c('td', {
      staticClass: "handle"
    }, [_c('div', [_c('div', [(_vm.canPay(item)) ? _c('button', {
      staticClass: "payBtn",
      on: {
        "click": function($event) {
          return _vm.singlePay(item)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e()]), _vm._v(" "), _c('div', [(item.auditionIds) ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.lookVoiceList(item)
        }
      }
    }, [_vm._v("查看试音")]) : _vm._e()]), _vm._v(" "), (item.payId) ? _c('router-link', {
      staticClass: "discuss",
      attrs: {
        "to": {
          name: 'Discuss',
          query: {
            id: item.orderNum
          }
        }
      }
    }, [_vm._v(_vm._s(item.dubbingGrade ? '查看评论' : '评价订单'))]) : _vm._e()], 1)])])]
  })], 2)]), _vm._v(" "), (_vm.summation || _vm.summation === 0) ? _c('div', {
    staticClass: "summation"
  }, [_c('p', [_vm._v("\n          合计实付金额： "), _c('span', [_vm._v(_vm._s(_vm.summation))]), _vm._v("元\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table_footer_tools"
  }, [_c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getStatistics()
      }
    }
  }, [_vm._v("查看合计")]), _vm._v(" "), _c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getExcel()
      }
    }
  }, [_vm._v("导出本页表格")]), _vm._v(" "), _c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": _vm.getAllExcel
    }
  }, [_vm._v("导出所有表格")])]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('app-page-ajax', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有检测到相关的订单~")])])]), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewVoice),
      expression: "viewVoice"
    }]
  }, [_c('div', {
    staticClass: "demo_voice_dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        您的试音\n        "), _c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.viewVoice = false
      }
    }
  })]), _vm._v(" "), _c('ul', _vm._l((_vm.voiceLists), function(vo, index) {
    return _c('li', {
      key: index,
      attrs: {
        "sound-id": vo.id
      }
    }, [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "dubber"
    }, [_vm._v(_vm._s(vo.auditionDubboNum + '号'))]), _vm._v(" "), _c('span', {
      staticClass: "voice",
      attrs: {
        "title": vo.auditionName
      }
    }, [_vm._v(_vm._s(vo.auditionName))]), _vm._v(" "), _c('i', {
      staticClass: "play sound-play"
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "viki_modal"
  }, [_c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forHelp),
      expression: "forHelp"
    }]
  }, [_c('div', {
    staticClass: "viki"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.first) ? _c('div', {
    staticClass: "first"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.first = false;
        _vm.orderViki.second = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.second) ? _c('div', {
    staticClass: "second"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.second = false;
        _vm.orderViki.third = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.third) ? _c('div', {
    staticClass: "third"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.third = false;
        _vm.forHelp = false;
      }
    }
  })]) : _vm._e()])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d289e48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/withinOrders.vue
// module id = 843
// module chunks = 1